import { ReactNode } from 'react';

import { useInitMixPanel } from '~/shared/hooks/useInitMixPanel';

const MixPanelProvider = ({ children }: { children: ReactNode }) => {
  useInitMixPanel();

  return <div>{children}</div>;
};

export default MixPanelProvider;
